// ─────────────────────────────────────────────────────────────────────────────
// Logo modulunun KENDI axios instance'i. Host projenin api/request.tsx'ine
// bagimli DEGIL — boylece klasoru kopyalayinca calisir.
// ─────────────────────────────────────────────────────────────────────────────

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { logoConfig } from '../config';
import { LogoResult } from '../types';

let instance: AxiosInstance | null = null;

/** Config'e gore (gerekirse yeniden) olusturulan paylasimli axios instance. */
export function logoClient(): AxiosInstance {
  if (!instance || instance.defaults.baseURL !== logoConfig.baseUrl) {
    instance = axios.create({
      baseURL: logoConfig.baseUrl,
      withCredentials: logoConfig.withCredentials, // cerez tabanli oturum
      timeout: logoConfig.timeoutMs,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    });
  }
  return instance;
}

/**
 * Cagriyi LogoResult'a sarar; hatayi UI dostu mesaja cevirir.
 * Tum api/* fonksiyonlari bunun uzerinden gider.
 */
export async function logoRequest<T>(cfg: AxiosRequestConfig): Promise<LogoResult<T>> {
  try {
    const res = await logoClient().request<T>(cfg);
    return { ok: true, data: res.data, status: res.status };
  } catch (e) {
    const err = e as AxiosError<any>;
    const status = err.response?.status;
    const message =
      (err.response?.data && (err.response.data.message || err.response.data.title)) ||
      err.message ||
      'Logo API hatasi';
    return { ok: false, status, message: String(message) };
  }
}
